export const SERVICES = {
  TMS: import.meta.env.VITE_SERVICE_TMS || '',
  FLAGGING: import.meta.env.VITE_SERVICE_FLAGGING || '',
  AUTH: import.meta.env.VITE_SERVICE_AUTH || '',
  FILE: import.meta.env.VITE_SERVICE_FILE || '',
};
